<template>
  <div class="certification-wrapper">
    <div class="certification-widget" v-if="is_items_list_open">
      <!-- Items list -->
      <ul class="certification-items" v-if="profile_data.certifications.length > 0">
        <li class="certification-starter">
          <div class="certification-item-header">
            <label>Certifications ({{
              profile_data.certifications.length | validate
            }})</label>
            <button class="btn-add" @click="addUpdateForm()">
              Add Certification +
            </button>
          </div>
        </li>
        <li class="certification-item" v-for="(item, i) in profile_data.certifications" :key="i">
          <panel-expand>
            <template v-slot:header="{ options }">
              <div class="certification-item-header" :class="{ no_expand: !options.expanded }"
                @click="options.expanded = true">
                <div class="certification-item-brand">
                  <img src="@/assets/icons/icon__edication.svg" alt />
                </div>
                <div class="content">
                  <div class="title-row">
                    <label>{{ item.name | validate }}</label>
                    <span>{{ item.organization | validate }}</span>
                    <span class="date">
                      <span v-if="item.from">{{
                        item.from | formatDate | validate
                      }}</span>
                    </span>
                  </div>
                  <div class="options">
                    <dropdown-menu>
                      <ul>
                        <li>
                          <a href @click.prevent="download(item.path)">Download</a>
                        </li>
                        <li>
                          <a href @click.prevent="editCertificate(item)">Edit</a>
                        </li>
                        <li>
                          <app-dialog title="Delete Certificate"
                            ask="Are you sure you want to permanently delete this certificate?" yesText="Delete"
                            yesBtnClass="btn-danger" noText="Cancel" @onComfirm="deleteCertificate(item.id, i)">
                            <a href="#">Delete</a>
                          </app-dialog>
                        </li>
                      </ul>
                    </dropdown-menu>

                    <button class="toogle-panel-btn" @click="options.expanded = !options.expanded"
                      v-if="!options.expanded">
                      <img src="@/assets/admin-icon/icon-down.svg" />
                    </button>
                  </div>
                </div>
              </div>
            </template>
            <template v-slot:main="{ options }">
              <div class="certification-item-body">
                <div class="certification-info">
                  <h5>Description</h5>
                  <p>{{ item.description | validate }}</p>
                </div>
                <div class="certification-item-body-option">
                  <button class="toogle-panel-btn" @click="options.expanded = !options.expanded">
                    <img src="@/assets/icons/up.svg" />
                  </button>
                </div>
              </div>
            </template>
          </panel-expand>
        </li>
      </ul>
      <!-- Empty widget -->
      <div class="empty-widget" v-else>
        <div class="empty-widgetheader">
          <label>Certifications</label>
        </div>
        <div class="empty-widget-body">
          <p>
            You have not yet added certifications yet,
            <br />Click below to add one
          </p>
          <button class="add-btn" @click="addUpdateForm()">
            Add Certification
          </button>
        </div>
      </div>
    </div>
    <!-- start of add & update certificate -->
    <div class="certification-add-update-widget" v-if="add_update_form">
      <div class="certification-add-update-header"></div>
      <div class="certification-add-update-body">
        <div class="input-widget">
          <div class="certification-upload">
            <label>Upload your certificate</label>
            <upload @onFileSelected="setCertificatefile" :max_size="5"
              caption="Upload your certificate [max-size: 5MB] [pdf,docs,png,jpeg]" remove_caption="Remove file" :value="{
                url: $fullUrl('files/certificates/'),
                file_name: certification.file_url,
              }" />
          </div>
        </div>
        <div class="input-widget">
          <span class="label">
            Document
            <i class="baseline-near_me"></i>
          </span>
          <div class="input">
            <input type="text" v-model="certification.name" placeholder="Eg: Certificate of Participation" />
          </div>
        </div>
        <div class="input-widget">
          <span class="label">Institution</span>
          <div class="input">
            <input type="text" v-model="certification.organization" placeholder="Eg: International Business Company" />
          </div>
        </div>
        <div class="input-widget">
          <span class="label">Date of Certification</span>
          <div class="input">
            <datepicker :monday-first="true" placeholder="Select date" v-model="certification.date_of_certification"
              wrapper-class="date-picker"></datepicker>
          </div>
        </div>
        <div class="input-widget">
          <span class="label">Description</span>
          <div class="input">
            <textarea type="text" v-model="certification.description" placeholder="Certificate description"></textarea>
          </div>
        </div>
      </div>
      <div class="certification-add-update-footer">
        <consultfied-button @click="addUpdateCertification()" :loading="save_training_cert"
          class="btn-save">Save</consultfied-button>
        <a href class="btn-cancel" @click.prevent="closeUpdateForm()">Cancel</a>
      </div>
    </div>
    <!-- end of add & update certificate -->

    <!-- Start certificate modal -->
    <div class="modal-overlay" v-if="certificate_modal">
      <div class="modal">
        <div class="modal-header">
          <span></span>
          <button @click="certificate_modal = false" class="close-btn">
            &times;
          </button>
        </div>
        <div class="modal-body" v-if="modal_image_src">
          <img :src="modal_image_src" alt />
        </div>
        <div class="modal-footer">
          <div class="content">
            <span>{{ selected_cert.name | validate }}</span>
            <strong>{{ selected_cert.description | validate }}</strong>
          </div>
          <div class="option">
            <a href="#" @click="download(selected_cert.path)" class="download-btn">
              Downlaod
              <span class="fa fa-download"></span>
            </a>
          </div>
        </div>
      </div>
    </div>
    <!-- End certificate modal -->
  </div>
</template>
<script>
import appDialog from "@/components/Dialog/AppDialog.vue";
import Datepicker from "vuejs-datepicker";
import upload from "@/components/Partials/Uploader.vue";
import consultfiedButton from "@/components/helper/consultfiedButton.vue";
import { eventBus } from "@/main";
import { mapGetters } from "vuex";
import { API } from "@/Store/variable";
import moment from "moment";
import panelExpand from "@/components/Partials/panelExpand";

export default {
  name: "certification",
  components: {
    appDialog,
    Datepicker,
    upload,
    consultfiedButton,
    panelExpand,
  },
  props: {
    company_id: {
      type: Number,
      default: null,
    },
    id: {
      type: Number,
      default: null,
    },
  },
  data: () => {
    return {
      add_update_form: false,
      is_items_list_open: true,
      certificate_modal: false,
      selected_cert: {},
      modal_image_src: "",
      certification: {
        id: null,
        name: "",
        organization: "",
        date_of_certification: "",
        description: "",
        file: null,
        file_url: "",
        type: "certification",
      },
      profile_data: {
        user: {},
        projects: [],
        skills: [],
        employment: [],
        educations: [],
        trainings: [],
        certifications: [],
      },
      save_training_cert: false,
    };
  },
  mounted() {
    let vm = this;
    vm.getConsultantData(vm.id);
  },
  computed: {},
  methods: {
    moment,
    deleteCertificate(id, i) {
      let vm = this;
      vm.$store
        .dispatch("COMPANY_CONSULTANT_DELETE_CERTIFICATION", {
          id: id,
          user_id: vm.id,
          type: "certification",
        })
        .then((responce) => {
          if (i > -1) {
            vm.profile_data.certifications.splice(i, 1);
          }
        })
        .catch((error) => {
          console.log({ error });
        });
    },
    editCertificate(item) {
      let vm = this;
      vm.is_items_list_open = false;
      vm.add_update_form = true;
      vm.certification.id = item.id;
      vm.certification.name = item.name || "";
      vm.certification.organization = item.organization || "";
      vm.certification.date_of_certification = vm.$dateObj(item.from);
      vm.certification.description = item.description || "";
      vm.certification.file = null;
      vm.certification.file_url = item.path || "";
    },
    addUpdateCertification() {
      let vm = this;
      vm.save_training_cert = true;
      let postFrmData = new FormData();
      postFrmData.append("user_id", vm.id);
      postFrmData.append("id", vm.certification.id);
      postFrmData.append("name", vm.certification.name);
      postFrmData.append("institution", vm.certification.organization);
      postFrmData.append(
        "date_of_certification",
        vm.moment(vm.certification.date_of_certification).format("DD-MM-YYYY")
      );
      postFrmData.append("description", vm.certification.description);
      if (vm.certification.file)
        postFrmData.append(
          "file",
          vm.certification.file,
          vm.certification.file.name
        );
      postFrmData.append("type", "certification");

      if (!vm.certification.id) {
        // Add new
        vm.$store
          .dispatch("COMPANY_CONSULTANT_ADD_NEW_CERTIFICATION", postFrmData)
          .then((responce) => {
            vm.save_training_cert = false;
            vm.getConsultantData(vm.id);
          })
          .catch((error) => {
            vm.save_training_cert = false;
            console.log({ error });
          });
      } else {
        // Update
        vm.$store
          .dispatch("COMPANY_CONSULTANT_UPDATE_CERTIFICATION", postFrmData)
          .then((responce) => {
            vm.save_training_cert = false;
            vm.getConsultantData(vm.id);
          })
          .catch((error) => {
            vm.save_training_cert = false;
            console.log({ error });
          });
      }
    },
    getConsultantData(id) {
      let vm = this;
      vm.$store
        .dispatch("GET_CONSULTANT_ALL_DATA", { id: id })
        .then((responce) => {
          vm.showItemsList();
          vm.profile_data = responce.data;
        })
        .catch((error) => {
          console.log({ error });
        });
    },
    setCertificatefile(file) {
      let vm = this;
      if (file) {
        vm.certification.file = file;
        vm.certification.file_url = "";
      }
    },
    viewCert(item, src) {
      let vm = this;
      vm.selected_cert = item;
      vm.certificate_modal = true;
      vm.modal_image_src = src;
    },
    download(fileName) {
      axios({
        method: "POST",
        data: { file_name: fileName },
        url: API + "/profile/get-file",
        headers: { Authorization: "Bearer " + sessionStorage.authToken },
        responseType: "blob",
      })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", fileName); //or any other extension
          document.body.appendChild(link);
          link.click();
        })
        .catch((error) => console.log(error));
    },
    closeUpdateForm() {
      let vm = this;
      vm.is_items_list_open = true;
      vm.add_update_form = false;
    },
    addUpdateForm() {
      let vm = this;
      vm.is_items_list_open = false;
      vm.add_update_form = true;
      vm.certification = {
        name: "",
        organization: "",
        date_of_certification: "",
        description: "",
        file: null,
      };
    },
    showItemsList() {
      let vm = this;
      vm.add_update_form = false;
      vm.is_items_list_open = true;
    },
  },
};
</script>
<style lang="scss" scoped>
.certification-wrapper {
  @media (min-width: 300px) and (max-width: 630px) {
    padding: 10px;
  }

  .certification-widget {
    width: 100%;

    ul.certification-items {
      padding: 0px 10px;
      padding-bottom: 20px;
      list-style: none;
      border-bottom-left-radius: 5px;
      border-bottom-right-radius: 5px;

      .certification-starter {
        margin-bottom: 6px;

        .certification-item-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 16px 0px;

          label {
            color: #000000;

            font-size: 16px;
          }

          .btn-add {
            color: #1ba5a4;
            border: none;
            padding: 10px 10px;
            font-size: 14px;
            outline: none;
            cursor: pointer;

            font-style: italic;
            background: transparent;
          }
        }

        p {
          color: #131313;
        }
      }

      .certification-item {
        background: #fff;
        border-radius: 5px;
        margin-bottom: 10px;
        position: relative;

        .certification-item-header {
          display: grid;
          padding-top: 25px;
          padding-left: 25px;
          padding-right: 25px;
          grid-template-columns: 60px calc(97% - 60px);
          grid-column-gap: 20px;

          &.no_expand {
            padding-bottom: 25px;

            &:hover {
              cursor: pointer;
              background: #e9e9e9;
              border-radius: 4px;
            }
          }

          @media (min-width: 300px) and (max-width: 630px) {
            grid-template-columns: 100%;
            grid-column-gap: 10px;
            padding: 10px 12px;
          }

          .certification-item-brand {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 60px;
            height: 60px;
            background: rgb(228, 228, 228);
            border-radius: 50%;

            @media (min-width: 300px) and (max-width: 630px) {
              width: 60px;
              height: 60px;
              display: none;
            }

            img {
              width: 54px;
              height: 54px;
              object-fit: contain;

              @media (min-width: 300px) and (max-width: 630px) {
                width: 33px;
                height: 33px;
              }
            }
          }

          .content {
            display: flex;
            justify-content: space-between;
            align-items: center;

            .title-row {
              padding-right: 9px;
              display: flex;
              flex-direction: column;
              justify-content: center;

              label {
                display: block;
                font-size: 14px;

                margin-bottom: 4px;

                @media (min-width: 300px) and (max-width: 630px) {
                  font-size: 12px;
                }
              }

              span {
                color: #808080;

                font-size: 13px;
                margin-bottom: 4px;

                @media (min-width: 300px) and (max-width: 630px) {
                  font-size: 12px;
                }
              }
            }

            .options {
              display: flex;
              align-items: flex-end;
              flex-direction: column;

              .btns {
                display: flex;
              }

              .verified-status {
                color: #0590ab;
                margin: 10px 0px;
              }

              .btn-verify {
                height: 40px;
                width: 100px;
                outline: none;
                color: #fff;
                background-color: #1890a9;
                border-radius: 5px;
              }

              .date {
                color: #808080;

                font-size: 13px;
                display: flex;
                justify-content: flex-end;
                width: 188px;
                align-items: center;
                margin-bottom: 22px;

                .separator {
                  margin: 0px 5px;
                }

                @media (min-width: 300px) and (max-width: 630px) {
                  font-size: 11px;
                  width: 145px;
                }
              }

              .status {
                color: #000;

                font-size: 13px;
              }

              .toogle-panel-btn {
                width: 19px;
                padding: 0;
                height: 22px;
                font-size: 20px;
                position: absolute;
                bottom: 5px;
                right: 20px;
              }
            }
          }

          .toogle-panel-btn {
            padding: 1px 40px;
            font-size: 30px;
            background: transparent;
            border: none;
            outline: none;
            cursor: pointer;
            color: #ccc;
          }
        }

        .certification-item-body {
          padding-bottom: 25px;
          padding-left: 25px;
          padding-right: 25px;

          .certification-info {
            h5 {
              text-align: left;
              color: #6e6e6e;
              font-size: 14px;
              margin-bottom: 5px;
            }

            p {
              text-align: left;
              color: #000;
              font-size: 13px;

              margin-top: 0px;
            }

            .collaboraters-widget {
              padding: 10px 0px;
              display: flex;
              flex-wrap: wrap;

              .item {
                background: #1ba5a4 0% 0% no-repeat padding-box;
                border-radius: 20px;
                display: flex;
                align-items: center;
                padding: 4px 4px;
                margin-right: 8px;
                margin-bottom: 8px;

                .profile-img {
                  width: 26px;
                  height: 26px;
                  border-radius: 50%;
                  margin-right: 5px;
                }

                .name {
                  color: #fff;
                }
              }
            }

            .skills-widget {
              .skills_content__wrapper {
                display: grid;
                grid-template-columns: 1fr 1fr 1fr;
                grid-column-gap: 10px;
                margin-bottom: 10px;

                @media (min-width: 300px) and (max-width: 630px) {
                  grid-template-columns: 1fr;
                }

                .skill_box {
                  min-width: 0;
                  display: flex;
                  flex-direction: column;
                  width: 100%;
                  background: #fff;
                  border-radius: 5px;
                  margin-bottom: 15px;

                  .skill_box_header {
                    border-bottom: 2px solid #f5f5f5;
                    height: 50px;
                    display: flex;
                    align-items: center;
                    justify-content: space-around;
                    padding: 0px 15px;

                    label {
                      color: #0884af;
                      width: 100%;
                      font-size: 15px;
                    }
                  }

                  .skill_box_body {
                    padding: 0px 15px;

                    .empty-skills {
                      display: flex;
                      flex-direction: column;
                      align-items: center;
                      height: 200px;
                      justify-content: center;

                      p {
                        text-align: center;
                        margin-bottom: 20px;
                        color: #8d8d8d;
                      }

                      button {
                        width: 133px;
                        height: 36px;
                        background: #1890a9 0% 0% no-repeat padding-box;
                        border-radius: 5px;
                        color: #fff;
                      }
                    }

                    .row__item {
                      margin-top: 10px;
                      display: flex;
                      margin-bottom: 10px;
                      justify-content: space-between;
                      width: 100%;

                      span {
                        color: #000000;
                        font-weight: normal;
                        margin-top: 2px;
                        font-size: 14px;
                      }
                    }
                  }
                }
              }

              .next_skills_content__wrapper {
                display: grid;
                grid-template-columns: 1fr 1fr;
                grid-column-gap: 10px;

                @media (min-width: 300px) and (max-width: 630px) {
                  grid-template-columns: 1fr;
                }

                .skill_box {
                  min-width: 0;
                  display: flex;
                  flex-direction: column;
                  width: 100%;
                  background: #fff;
                  border-radius: 5px;
                  margin-bottom: 15px;

                  .skill_box_header {
                    border-bottom: 2px solid #f5f5f5;
                    height: 50px;
                    display: flex;
                    align-items: center;
                    justify-content: space-around;
                    padding: 0px 15px;

                    label {
                      color: #0884af;
                      width: 100%;
                      font-size: 15px;
                    }
                  }

                  .skill_box_body {
                    padding: 0px 15px;

                    .empty-skills {
                      display: flex;
                      flex-direction: column;
                      align-items: center;
                      height: 200px;
                      justify-content: center;

                      p {
                        text-align: center;
                        margin-bottom: 20px;
                        color: #8d8d8d;
                      }

                      button {
                        width: 133px;
                        height: 36px;
                        background: #1890a9 0% 0% no-repeat padding-box;
                        border-radius: 5px;
                        color: #fff;
                      }
                    }

                    .row__item {
                      margin-top: 10px;
                      display: flex;
                      margin-bottom: 10px;
                      justify-content: space-between;
                      width: 100%;

                      span {
                        color: #000000;
                        font-weight: normal;
                        margin-top: 2px;
                        font-size: 14px;
                      }
                    }
                  }
                }
              }
            }
          }

          .certification-item-body-option {
            display: flex;
            justify-content: flex-end;

            .toogle-panel-btn {
              padding: 1px 9px;
              font-size: 30px;
              background: transparent;
              border: none;
              outline: none;
              cursor: pointer;
              color: #ccc;
              height: 36px;
              width: 19px;
              padding: 0;
              height: 22px;
              font-size: 20px;
              position: relative;
              top: -3px;
              right: -5px;
            }
          }
        }
      }
    }

    .empty-widget {
      background: #fff;
      padding: 20px;

      .empty-widget-body {
        height: 350px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;

        p {
          text-align: center;
          width: 270px;
        }

        .add-btn {
          width: 180px;
          height: 45px;
          background: #1890a9 0% 0% no-repeat padding-box;
          border-radius: 4px;
          color: #fff;
          outline: none;
          margin-right: 20px;
          display: center;
          justify-content: center;
        }
      }
    }
  }

  .certification-add-update-widget {
    width: 100%;
    padding: 0px 20px;

    .certification-add-update-header {}

    .certification-add-update-body {
      padding-bottom: 10px;
      padding-top: 10px;
      display: flex;
      flex-direction: column;

      label {
        display: block;
      }

      .certification-upload {
        width: 100%;
        height: 160px;
        margin-bottom: 20px;
      }

      .input-widget {
        margin-bottom: 25px;

        .label {
          display: block;

          margin-bottom: 5px;
          color: #6e6e6e;
        }

        .input {
          display: flex;

          .date-picker {
            width: 100%;
            background: #ffffff 0% 0% no-repeat padding-box;
            box-shadow: 0px 1px 3px #3b3b3b29;
            border: 1px solid rgb(219, 219, 219);
            border-radius: 5px;
            padding: 15px 10px;
            font-size: 14px;
            outline: none;
          }

          input {
            width: 100%;
            background: #ffffff 0% 0% no-repeat padding-box;
            box-shadow: 0px 1px 3px #3b3b3b29;
            border: 1px solid rgb(219, 219, 219);
            border-radius: 5px;
            padding: 15px 10px;
            font-size: 14px;
            outline: none;
          }

          textarea::placeholder,
          input::placeholder {
            font-style: normal !important;
            color: #707070;
          }

          textarea {
            width: 100%;
            height: 150px;
            background: #ffffff 0% 0% no-repeat padding-box;
            box-shadow: 0px 1px 3px #3b3b3b29;
            border: 1px solid rgb(219, 219, 219);
            border-radius: 5px;
            padding: 15px 10px;
            font-size: 14px;
            outline: none;
          }
        }
      }
    }

    .certification-add-update-footer {
      display: flex;
      align-items: center;
      width: 100%;

      .btn-save {
        background: transparent linear-gradient(267deg, #1885ad 0%, #04a5a5 100%) 0% 0% no-repeat padding-box;
        border-radius: 5px;
        padding: 12px 30px;
        text-decoration: none;
        color: #fff;

        margin-right: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .btn-cancel {
        border-radius: 5px;
        padding: 12px 10px;
        text-decoration: none;
        color: #1885ad;

        margin-right: 20px;
      }
    }
  }

  .modal-overlay {
    position: fixed;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    background: rgba($color: #000000, $alpha: 0.89);
    z-index: 9999;
    display: flex;
    justify-content: center;
    padding-top: 50px;
    padding-bottom: 50px;
    overflow-y: auto;

    .modal {
      width: 600px;
      background: #1ba5a4 0% 0% no-repeat padding-box;
      border-radius: 5px;
      display: inline-table;
      padding-bottom: 10px;

      .modal-header {
        display: flex;
        justify-content: space-between;
        padding: 10px;

        .close-btn {
          color: #fff;
          font-size: 25px;
          outline: none;
          background: transparent;
          border: none;
          cursor: pointer;
        }
      }

      .modal-body {
        padding-left: 40px;
        padding-right: 40px;

        img {
          width: 100%;
        }
      }

      .modal-footer {
        padding: 10px;
        padding-left: 50px;
        padding-right: 50px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .content {
          display: flex;
          flex-direction: column;

          span {
            color: #fff;

            margin-bottom: 7px;
          }

          strong {
            color: #fff;
          }
        }

        .option {
          .download-btn {
            border: 1px solid rgb(247, 247, 247);
            color: #fff;
            padding: 8px 20px;
            text-decoration: none;

            border-radius: 5px;
            font-size: 14px;
            width: 129px;
            display: block;
          }
        }
      }
    }
  }
}
</style>